import { AddressByCompanyBuyerRequest } from '@/main/models/request';
import { BillingAddressTypes, BillingAddressActionTypes } from './billingAddressTypes';
import { AddressByBodyshopResponse } from '@/main/models/response';

export function getBillingAddress(request: AddressByCompanyBuyerRequest): BillingAddressActionTypes {
  return {
    type: BillingAddressTypes.GET_BILLING_ADDRESS,
    payload: { request }
  };
}

export function saveBillingAddress(
  data: AddressByBodyshopResponse[] | null,
  isError: boolean,
  errorMessages: string[] | null
): BillingAddressActionTypes {
  return {
    type: BillingAddressTypes.SAVE_BILLING_ADDRESS,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerBillingAddress(): BillingAddressActionTypes {
  return {
    type: BillingAddressTypes.RESET_REDUCER_BILLING_ADDRESS
  };
}
